import React, { Component } from 'react';
import { Header, Segment, Table } from 'semantic-ui-react';
import { IWorkstation } from '@relab/alstom-ptw-shared';

import { WorkstationDeleteModal } from './WorkstationDeleteModal';
import { WorkstationEditModal } from './WorkstationEditModal';
import { TranslationComponent } from '../TranslationComponent';

interface WorkstationsListComponentProps {
  workstations: IWorkstation[];
}

interface WorkstationsListComponentState {
  column: string;
  sortedWorkstations: IWorkstation[];
  direction: 'descending' | 'ascending';
}

export class WorkstationsListComponent extends Component<WorkstationsListComponentProps> {
  state: WorkstationsListComponentState = {
    column: 'name',
    sortedWorkstations: [],
    direction: 'ascending',
  };

  componentDidUpdate(prevProps: Readonly<WorkstationsListComponentProps>) {
    if (this.props.workstations !== prevProps.workstations) {
      this.setState({
        sortedWorkstations: this.props.workstations,
      });
    }
  }

  handleSort = (clickedColumn: string) => () => {
    const { workstations } = this.props;
    const { column, sortedWorkstations, direction } = this.state;

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        sortedWorkstations: workstations.sort((a: any, b: any) => (a[clickedColumn] > b[clickedColumn] ? -1 : 1)),
        direction: 'ascending',
      });

      return;
    }

    this.setState({
      sortedWorkstations: sortedWorkstations.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    });
  };

  render() {
    const { column, direction, sortedWorkstations } = this.state;

    return (
      <Segment>
        <Header as="h2">
          <TranslationComponent
            stringKey={'Workstation list ({{length}})'}
            values={{ length: sortedWorkstations.length }}
          />
        </Header>

        <Table sortable celled fixed>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell sorted={column === 'name' ? direction : null} onClick={this.handleSort('name')}>
                <TranslationComponent stringKey={'Name'} />
              </Table.HeaderCell>
              <Table.HeaderCell />
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {sortedWorkstations.map((workstation) => (
              <Table.Row key={workstation._id}>
                <Table.Cell>{workstation.name}</Table.Cell>
                <Table.Cell textAlign="right">
                  <WorkstationEditModal workstation={workstation} />
                  <WorkstationDeleteModal workstation={workstation} />
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Segment>
    );
  }
}
